<script lang="ts">
  import { onMount } from "svelte";
  import { environment } from "$utils/env";

  let { children } = $props();

  let show = $state(false);
  let environmentName = $state("");

  onMount(async () => {
    environmentName = (await environment).environment;
    show = environmentName !== "production";
    document.documentElement.classList.toggle("has-banner", show);
  });
</script>

{#if show}
  <div class="sticky top-0 start-0 z-50 w-full">
    <div class="relative isolate flex items-center gap-x-6 overflow-hidden bg-amber-400 px-6 py-2.5 sm:px-3.5">
      <div class="flex flex-1" aria-hidden="true"></div>
      <div class="flex flex-wrap items-center gap-x-4 gap-y-2">
        <p class="text-sm/6 !text-gray-900">
          <strong class="font-semibold">Warning!</strong>
          <svg viewBox="0 0 2 2" class="mx-2 inline size-0.5 fill-current" aria-hidden="true">
            <circle cx="1" cy="1" r="1" />
          </svg>
          You are currently viewing the {environmentName} dashboard.
        </p>
        <a
          href="https://dashboard.redactive.ai"
          class="flex-none rounded-full bg-gray-900 px-3.5 py-1 text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
        >
          Switch to Production
          <span aria-hidden="true">&rarr;</span>
        </a>
      </div>
      <div class="flex flex-1" aria-hidden="true"></div>
    </div>
  </div>
{/if}

<div class="content-wrapper relative flex-grow">
  {@render children()}
</div>

<style>
  :global(:root) {
    --banner-height: 0px;
  }

  :global(:root.has-banner) {
    --banner-height: 48px;
  }
</style>
